'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$0024less$0024colon$0024less from "./scala.$less$colon$less.js";
var $p;
/** @constructor */
function $c_s_$eq$colon$eq() {
}
export { $c_s_$eq$colon$eq as $c_s_$eq$colon$eq };
$p = $c_s_$eq$colon$eq.prototype = new $j_scala$002e$0024less$0024colon$0024less.$h_s_$less$colon$less();
$p.constructor = $c_s_$eq$colon$eq;
/** @constructor */
function $h_s_$eq$colon$eq() {
}
export { $h_s_$eq$colon$eq as $h_s_$eq$colon$eq };
$h_s_$eq$colon$eq.prototype = $p;
